import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../ui/dialog';

interface DeleteConfirmationModalProps {
  open: boolean;
  activityTitle: string;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export default function DeleteConfirmationModal({ open, activityTitle, onClose, onConfirm, isLoading }: DeleteConfirmationModalProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onClose(); }}>
      <DialogContent data-testid="delete-confirmation-modal" className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-display text-[20px]">Delete Activity?</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete <span className="font-semibold">{activityTitle}</span>? This will remove it from all lists.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-semibold rounded-pine-input border-[1.5px] border-pine-line text-pine-ink-soft hover:bg-pine-hover-button transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            data-testid="delete-confirm-button"
            onClick={onConfirm}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-semibold rounded-pine-input border-[1.5px] border-pine-danger text-pine-danger hover:bg-pine-danger hover:text-white transition-colors disabled:opacity-50"
          >
            {isLoading ? 'Deleting...' : 'Delete'}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
